const b = (type, text = "", checked = false) => ({ type, text, checked });

export const TEMPLATES = [
  { key: "blank", icon: "📄", title: "صفحة فارغة", blocks: [b("text")] },
  { key: "minutes", icon: "📝", title: "محضر اجتماع", blocks: [
    b("h2", "معلومات الاجتماع"), b("text", "التاريخ: "), b("text", "الحضور: "),
    b("h2", "جدول الأعمال"), b("bullet", ""), b("h2", "القرارات"), b("bullet", ""),
    b("h2", "المهام"), b("todo", ""), b("h2", "الاجتماع القادم"), b("text", "")] },
  { key: "project", icon: "🚀", title: "خطة مشروع", blocks: [
    b("h2", "الهدف"), b("text", ""), b("h2", "النطاق"), b("bullet", ""),
    b("h2", "المراحل والمواعيد"), b("todo", "المرحلة 1 — "), b("todo", "المرحلة 2 — "),
    b("h2", "الفريق والمسؤوليات"), b("bullet", ""), b("h2", "المخاطر"), b("bullet", ""), b("h2", "مؤشرات النجاح"), b("bullet", "")] },
  { key: "sop", icon: "📘", title: "إجراء عمل (SOP)", blocks: [
    b("h2", "الغرض"), b("text", ""), b("h2", "النطاق"), b("text", ""), b("h2", "المسؤوليات"), b("bullet", ""),
    b("h2", "خطوات الإجراء"), b("bullet", "1. "), b("bullet", "2. "), b("h2", "النماذج المرتبطة"), b("bullet", ""), b("quote", "آخر مراجعة: ")] },
  { key: "weekly", icon: "📊", title: "تقرير أسبوعي", blocks: [
    b("h2", "إنجازات الأسبوع"), b("bullet", ""), b("h2", "الأرقام الرئيسية"), b("bullet", "الطلبات: "), b("bullet", "الإيراد: "),
    b("h2", "التحديات"), b("bullet", ""), b("h2", "خطة الأسبوع القادم"), b("todo", "")] },
];
